(function () {
	angular
		.module('trackeye')
		.controller('DeviceController', DeviceController);

	DeviceController.$inject = ["$scope", "$q", "DeviceService", "TagService", "FleetService", "InviteService", "NotificationService", "ModalService", "$state", "ImageService", "AppFactory"];

	function DeviceController($scope, $q, DeviceService, TagService, FleetService, InviteService, NotificationService, ModalService, $state, ImageService, AppFactory) {
		var vm = this;

		vm.is_loading = false;

		vm.formData = {};
		vm.deviceForm = {};
		vm.batteryForm = {};
		vm.shareForm = {};
		vm.echotagForm = {};

		vm.device = DeviceService.getSelectedDevice();
		vm.invites = InviteService.getCollection();
		vm.selected_fleet = vm.device ? vm.device.getFleet() : {};
		vm.fleets = FleetService.getFleets();
		vm.formData.name = vm.device ? vm.device.getName() : null;
		vm.formData.description = vm.device ? vm.device.getDescription() : null;
		vm.formData.notes = vm.device ? vm.device.configuration.get('description') : null;
		vm.formData.image = vm.device ? vm.device.configuration.get('image') : null;
		vm.selected_tag = undefined;

		var shareModal = ModalService.create('share-device', vm),
			editShareModal = ModalService.create('edit-share', vm),
			tagModal = ModalService.create('add-rftag', vm),
			replaceBatteryModal = ModalService.create('replace-battery', vm);

		vm.appSenders = AppFactory.appSenders
		$scope.$on('DeviceService.selected', function (e, device) {
			vm.invites = InviteService.getCollection();
			vm.selected_fleet = device.getFleet();
			vm.formData.name = device.getName();
			vm.formData.description = device.getDescription();
			vm.formData.notes = device.configuration.get('description');
			vm.formData.image = device.configuration.get('image');
			vm.device = device;
		});

		vm.openReplaceBatteryModal = function() {
			replaceBatteryModal.open();
		};

		vm.openShareDeviceModal = function(invite_id) {
			if (angular.isDefined(invite_id)) {
				editShareModal.open();
				editShareModal.scope.invite_id = invite_id;
				vm.selected_invite = InviteService.getById(invite_id).pop();
			} else {
				shareModal.open();
			}
		};

		vm.openAddTagModal = function(tag_id) {
			vm.selected_tag = tag_id ? TagService.getEchotagById(vm.device.getUuid(), tag_id) : undefined;

			tagModal.open();
			tagModal.scope.echo = vm.getEchotagInstance();
		};

		vm.hideSettings = function() {
			return !DeviceService.hasSutDevices()
		}

		vm.settingsHiddenMessage = function() {
			if (!DeviceService.hasSutDevices()) {
				return "STR_NO_DEVICES";
			}
		}

		vm.getDeviceDescription = function () {
			if (vm.device.loaded) {
				if (AppFactory.isDefault()) {
					return vm.device.features.description + " (" + vm.device.model + ")";
				} else {
					return vm.device.model;
				}
			}
			return null;
		};

		vm.getEchotagInstance = function () {
			return vm.selected_tag || TagService.newEchotag();
		};

		vm.editTag = function (id) {
			$state.go("dashboard.main.pages.modal", {modal: 'add-rftag', eventData: id});
		};

		vm.deleteTag = function (tag) {
			isWorking(true);
			if (tag.isNew()) {
				isWorking(false);
				return;
			}

			TagService.deleteEchotag(vm.device, tag).then(function () {
				vm.device.echotags = vm.device.echotags.filter(function (dev_tag) {
					return dev_tag.getId() != tag.getId()
				});
				tagModal.close();
			}).finally(isNotWorking);
		};

		vm.showTagModelField = function (tag) {
			if (!tag.isNew())
				return true;

			return tag.isPrefetched() && tag.isNew();
		};

		vm.saveTag = function (tag) {
			if (!vm.echotagForm.$valid)
				return;

			isWorking(true);

			TagService.saveEchotag(vm.device, tag)
				.then(function() {
					tagModal.close();
				})
				.catch(function(data) {
					if (data.model === 404) {
						vm.echotagForm.$setPristine();
					} else if (data.model === 400) {
						vm.echotagForm.$setValidity('model_exist', false);
					}
				})
				.finally(function() {
					isWorking(false);
				});
		};

		vm.triggerFileChange = function (element) {
			var image_uuid = vm.device.configuration.get('imagev2.uuid'),
				file = element.files[0];

			if (!file)
				return;

			isWorking(true);

			ImageService
				.save(file, image_uuid)
				.then(saveImageToDevice, function(err) {
					NotificationService.warning(err.message);
					isNotWorking();
				});
		};

		function saveImageToDevice(data) {
			vm.device.setImage(data.uuid, data.ext).then(function() {
				NotificationService.info('STR_IMAGE_SAVED')
			}).finally(isNotWorking);
		}

		vm.triggerFileClick = function () {
			document.getElementById('image_upload').click();
		};

		vm.hasInvites = function () {
			return !!vm.invites.length;
		};

		vm.deviceIsSharedWith = function () {
			if (!vm.device)
				return [];

			return vm.invites.filter(function (invite) {
				return invite.hasDevice(vm.device.id);
			});
		};

		vm.registerBatteryReplacement = function (code) {
			vm.batteryForm.$setValidity('incorrectOrUsed', true);
			if (!vm.batteryForm.$invalid) {
				isWorking(true);
				vm.device.registerBatteryReplacement(code).then(function () {
					$state.go('^');
					NotificationService.info('STR_BATTERY_REPLACEMENT_REGISTERED')
				}, function (response) {
					if (response.status == 404) {
						vm.batteryForm.$setValidity('incorrectOrUsed', false);
					}
				}).finally(isNotWorking);
			}
		};

		vm.deleteShare = function (inviteId) {
			isWorking(true);

			InviteService.delete(inviteId, vm.device).then(function () {
				editShareModal.close();
				NotificationService.info('STR_SHARE_WAS_DELETED');
			}).finally(isNotWorking);
		};

		vm.saveShare = function (share) {
			var invite = vm.selected_invite;
			invite.setPermissions(share.type, vm.device);

			isWorking(true);

			if (share.expire instanceof Date) {
				if (!invite.setExpire(share.expire)) {
					vm.shareForm.$setValidity('expire_too_early', false);
					isWorking(false);
					return;
				} else {
					vm.shareForm.$setValidity('expire_too_early', true);
				}
			}

			invite.save().then(function () {
				NotificationService.info('STR_SHARE_UPDATED');
				editShareModal.close()
			}).finally(isNotWorking);
		};

		vm.shareDevice = function (share) {
			var invite = InviteService.factory(share.email);

			isWorking(true);

			invite
				.setUser(share.email)
				.setDevice(vm.device)
				.setPermissions(share.type, vm.device);

			if (share.expire instanceof Date) {
				if (!invite.setExpire(share.expire)) {
					vm.shareForm.$setValidity('expire_too_early', false);
				} else {
					vm.shareForm.$setValidity('expire_too_early', true);
				}
			}

			if (vm.shareForm.$invalid) {
				isWorking(false);
				return;
			}

			invite.save().then(function () {
				InviteService.add(invite);
				NotificationService.info('STR_SHARE_CREATED');
			}).finally(function () {
				isWorking(false);
				shareModal.close();
			});
		};

		/**
		 * @todo add description
		 * @param data
		 */
		vm.saveDevice = function () {
			if (!vm.deviceForm.$dirty)
				return;

			isWorking(true);

			var qAll = [];

			if (vm.deviceForm.name.$dirty || vm.deviceForm.description.$dirty) {
				qAll.push(DeviceService.updateDevice(vm.device, {
					name: vm.formData.name,
					description: vm.formData.description
				}).$promise);
			}

			var config = vm.device.configuration;

			if (vm.selected_fleet.name == "STR_NO_MARKER") {
				config.set('fleet', null);
			} else {
				config.set('fleet', vm.selected_fleet.name);
			}

			config.set('description', vm.formData.notes);

			qAll.push(config.save(vm.device.getHref()).then(function () {
				vm.device.fleet = (vm.selected_fleet.name == "STR_NO_MARKER" ? null : vm.selected_fleet);
			}));

			$q.all(qAll).finally(function() {
				isNotWorking();
				vm.device.setDescription(vm.formData.description)
				vm.deviceForm.name.$setPristine();
				vm.deviceForm.description.$setPristine();
			});
		};

		vm.isWorking = isWorking;

		function isWorking(value) {
			if (!angular.isDefined(value))
				return vm.is_loading;

			return vm.is_loading = !!value;
		}

		function isNotWorking() {
			isWorking(false);
		}

		function isValidImage(file) {
			var allowed = ['png','jpg','jpeg'],
				valid = file.type.match(/image\/(.+)/);

			if (!valid)
				return false;

			return allowed.indexOf(valid[1]) >= 0;
		}
	}
})();